import React from 'react';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import SelectionController from './SelectionController';

/**
 * @typedef ExtensionActionItemProps
 * @prop {{name: string, identifier: string}} extension
 * @prop {import('./models/RecordAction').default[]} actions
 */

/**
 * @type {React.FC<ExtensionActionItemProps>}
 */
const ExtensionActionItem = ({ extension, actions }) => {
  const controller = useController(SelectionController);

  // eslint-disable-next-line no-undef
  const icon = aha.iconForExtensionIdentifier(extension.identifier);

  return (
    <aha-menu-item>
      <aha-menu submenu>
        <aha-button kind='link' slot='control'>
          {icon && <aha-icon icon={icon} />}
          {extension.name}
        </aha-button>
        <aha-menu-content>
          {actions.map(action => {
            const { command } = action;
            return (
              <aha-menu-item
                key={command.identifier}
                onClick={() => {
                  controller.actionTriggerExtensionCommand(action);
                }}
              >
                {command.name}
              </aha-menu-item>
            );
          })}
        </aha-menu-content>
      </aha-menu>
    </aha-menu-item>
  );
};

export default view(ExtensionActionItem);
